import Api from './api'
export function cacheDrafts(step, params) {
	const formItem = sessionStorage.getItem('formItem')
	let data = {}
	try {
		data = JSON.parse(formItem)
	} catch {
		data = {}
	}
	const { planName } = data
	Api.postApi_header('/draft/plan/cache', '', {
		planName: planName,
		planInfo: formItem,
		step: step,
		...params,
	})
}
